import { render, staticRenderFns } from "./NewCustomerDetails.vue?vue&type=template&id=6f35eaa8&scoped=true&"
import script from "./NewCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./NewCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomerDetails.vue?vue&type=style&index=0&id=6f35eaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35eaa8",
  null
  
)

export default component.exports